import { useMemo, ComponentType } from "react";
import styled from "styled-components";

import { CustomerNestedListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-list-items/CustomerExtendedListItem";
import { CustomerListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-list-items/CustomerListItem";
import { DeviceListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-list-items/DeviceListItem";
import { FarmListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-list-items/FarmListItem";
import { PartListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-list-items/PartListItem";
import { TechnicianListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-list-items/TechnicianListItem";
import {
    SearchResultItemType,
    SearchResultItem,
} from "@/components/layout/Navbar/ApplicationSearch/application-search.types";
import { useHasUserArea } from "@/hooks/useHasUserArea";
import { useAppSelector } from "@/store";
import { normalize } from "@/utils/string.utils";

const RecentSearchListStyled = styled.div`
    width: 100%;
`;

const itemComponentMap: Record<SearchResultItemType, ComponentType<any>> = {
    customer: CustomerListItem,
    customerExtended: CustomerNestedListItem,
    device: DeviceListItem,
    farm: FarmListItem,
    technician: TechnicianListItem,
    part: PartListItem,
};

type Props = {
    query: string;
    onClick: (item: SearchResultItem) => void;
};

const RecentSearch = ({ query, onClick }: Props) => {
    const recentSearches = useAppSelector((state) => state.recentSearch.recentSearches);
    const hasPartsArea = useHasUserArea(["TSS_Parts"]);

    const filteredRecentSearches = useMemo(() => {
        const accessibleRecentSearches = hasPartsArea
            ? recentSearches
            : recentSearches.filter((item) => item.type !== "part");

        if (query.length === 0) return accessibleRecentSearches;

        const lowerQuery = normalize(query);

        return accessibleRecentSearches.filter((item) => {
            return normalize(item.sortValue).includes(lowerQuery);
        });
    }, [query, hasPartsArea, recentSearches]);

    if (filteredRecentSearches.length === 0) {
        return null;
    }

    return (
        <>
            <RecentSearchListStyled>
                {filteredRecentSearches.map((item, index) => {
                    const ItemComponent = itemComponentMap[item.type];
                    return <ItemComponent key={index} data={item.data} onClick={onClick} isRecentSearch={true} />;
                })}
            </RecentSearchListStyled>
        </>
    );
};

export { RecentSearch };
